// Convert a designer-library DesignerRule into a typed canvas
// composition (WHEN / IF / THEN / BECAUSE nodes) the Rule Builder
// can render and persist.
//
// Per CLAUDE.md §1 + user direction: rules are 100% ontology-typed.
// DesignerRule.predicate IS the typed AST — no parsing. This
// converter just lays out the four canvas nodes and copies the
// typed predicate verbatim.

import type { DesignerRule } from "../data/designerRules";
import type { CanvasNode, RuleEvent, Action } from "../types/rule";

const KNOWN_EVENTS: ReadonlySet<RuleEvent> = new Set<RuleEvent>([
  "onSave", "onBOQRowAdded", "onSkuChanged", "onMilestoneSet",
  "onApprovalDecided", "onBudgetChanged", "onDeadlineChanged",
]);

function coerceEvent(trigger: string): RuleEvent {
  if ((KNOWN_EVENTS as Set<string>).has(trigger)) return trigger as RuleEvent;
  return "onSave";
}

function coerceAction(rule: DesignerRule): Action {
  switch (rule.action) {
    case "flag":         return { kind: "flag", severity: rule.severity };
    case "suggest":      return { kind: "suggest", query: rule.id };
    case "openApproval": return { kind: "openApproval", role: "client" };
    case "substitute":   return { kind: "substitute", criteria: { maxLeadDays: 21, minStyleMatch: 0.85, maxPriceDeltaPct: 0.15 } };
    case "redistribute": return { kind: "suggest", query: "redistribute" };
  }
}

export function designerRuleToCanvas(rule: DesignerRule): CanvasNode[] {
  return [
    { id: `${rule.id}-when`,    kind: "WHEN",    position: [40, 40],  data: { kind: "WHEN",    event: coerceEvent(rule.trigger) } },
    { id: `${rule.id}-if`,      kind: "IF",      position: [40, 170], data: { kind: "IF",      predicate: rule.predicate } },
    { id: `${rule.id}-then`,    kind: "THEN",    position: [40, 320], data: { kind: "THEN",    action: coerceAction(rule) } },
    { id: `${rule.id}-because`, kind: "BECAUSE", position: [40, 460], data: { kind: "BECAUSE", template: rule.because } },
  ];
}
